export const OtpClockIcon = ({ ...props }: any) => (
  <svg width={70} height={70} fill="none" {...props}>
    <circle
      cx={35}
      cy={35}
      r={33.6}
      fill="#fff"
      stroke="var(--color-blue)"
      strokeWidth={2.8}
    />
    <path
      stroke="var(--color-blue)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.625}
      d="M52.5 35c0 9.66-7.84 17.5-17.5 17.5S17.5 44.66 17.5 35 25.34 17.5 35 17.5 52.5 25.34 52.5 35Z"
    />
    <path
      stroke="var(--color-blue)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.625}
      d="m41.492 40.563-5.425-3.237c-.945-.56-1.715-1.908-1.715-3.01V27.14"
    />
  </svg>
);
